import type { ErrorEvent, EventHint } from "@sentry/nextjs";

const METAMASK_ERRORS = [
  "MetaMask extension not found",
  "Failed to connect to MetaMask",
] as const;

/**
 * Shared Sentry beforeSend filter to suppress known non-actionable errors.
 * Centralized to avoid duplication across sentry.edge.config.ts,
 * sentry.server.config.ts, and src/instrumentation-client.ts.
 */
export function filterMetaMaskErrors(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  const error = hint?.originalException;
  const errorMessage = typeof error === 'string'
    ? error
    : (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string')
      ? error.message
      : '';

  // Filter out MetaMask connection errors
  const isMetaMaskError = METAMASK_ERRORS.some(msg =>
    errorMessage.includes(msg) || event.message?.includes(msg)
  );

  if (isMetaMaskError) {
    return null;
  }

  return event;
}
